export enum Messages {
	EXCEPTION_FOR_FETCHING_CLIENT = 'An error occurred while fetching client data.',
	EXCEPTION_FOR_FETCHING_AUTHORIZATION = 'An error occurred while fetching authorization data.',
}
